import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class BillService {
  url: string = 'bills';

  constructor(private httpClient: HttpClientService) {}

  getBills(search_params: any): Promise<any> {
    search_params.search_bills = true;
    return this.httpClient.get(`${this.url}.json`, search_params);
  }

  getSearchOptions(params: any = {}): Promise<any> {
    params.get_search_options = true;
    return this.httpClient.get(`${this.url}.json`, params);
  }

  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params)
  }
}
